import { useCallback } from 'preact/hooks';

export const useInput = setter => useCallback(({ target: { value } }) => setter(value), [setter]);

export default useInput;